export const errorParser = (errors: string): any[] => {
  if (!errors) return [];
  // eslint-disable-next-line
  return errors.replace(/[\['\]]/g, '').split(',');
};
